export default "/images/1cb803dd31fc376445834ef47152ee4a.avif";